import { useDispatch, useSelector } from "react-redux"
import { VendorState } from "../../redux/vendor/rootReducer"
import { useEffect } from "react"
import { setLoading } from "../../redux/vendor/ui/uiActions"
import { LoadingOverlay } from "../../components/design-system/common"

export const Loader = () => {
    const { isLoading, loadingMessage } = useSelector((state: VendorState) => state.ui);
    const dispatch = useDispatch()

    useEffect(() => {
        // Auto-hide after 15 seconds as a safety mechanism
        if (isLoading) {
            const timeout = setTimeout(() => {
                dispatch(setLoading(false, "Loading..."))
            }, 15000);

            return () => clearTimeout(timeout);
        }
    }, [isLoading, dispatch])

    return <LoadingOverlay open={isLoading} message={loadingMessage} transparent={true} />
}